module.exports = __webpack_public_path__ + "static/media/md.07c6401e.webp";